import { useSelector } from "react-redux";
import DoubleStar from '../../assets/common/DoubleStar.svg';
import Image from '../../components/general/Image';

const EducationLanguages = () => {
    const { developer: { detail } } = useSelector(state => state.common);
    return (
        <div className="lg:mt-[80px]">
            <div className="lg:grid lg:grid-cols-2 lg:justify-start lg:items-stretch gap-[20px]">
                <Education {...{ detail }} />
                <Languages {...{ detail }} />
            </div>
        </div>
    );
};
const Education = ({ detail }) => {
    if (!detail?.graduation_year && !detail?.degree && !detail?.education) return null
    return <div className="flex flex-col h-full">
        <h3 className="text-[30px] font-bold flex justify-start min-h-[60px] items-center">
            <span>Education</span>
            <Image src={DoubleStar} alt="double-star" className="w-[40px] h-[40px] hidden lg:block translate-y-[-10px]" />
        </h3>
        <div className="bg-[#292929] text-white text-[13px] px-[10px] py-[5px] rounded-[6px] w-[80%] mt-[10px] flex-1 flex flex-col justify-center">
            <p className="font-extralight">{detail?.graduation_year}</p>
            <p className="font-bold text-[16px] ">{detail?.education}</p>
            <p className="font-light text-[16px]">{detail?.degree}</p>
        </div>
    </div>
};
const Languages = ({ detail }) => {
    if (!Boolean(detail?.languages?.length)) return null;
    return <div className="flex flex-col h-full my-[20px] lg:my-[0px]">
        <h3 className="text-[30px] font-bold flex justify-start min-h-[60px] items-center">
            <span>Languages</span>
            <Image src={DoubleStar} alt="double-star" className="w-[40px] h-[40px] hidden lg:block translate-y-[-10px]" />
        </h3>

        <div className="bg-[#292929] text-white text-[13px] px-[10px] py-[10px] rounded-[6px] w-[80%] mt-[10px] flex flex-wrap gap-[10px] h-full flex-1 items-start">
            {
                detail?.languages?.map((language, index) => (
                    <p className={index !== 0 ? 'border-l border-gray-500 pl-[10px] h-[20px]' : ''} key={index}>{language}</p>
                ))
            }
        </div>
    </div>
}
export default EducationLanguages;